export default {
  props: {
    identifier: {
      type: String,
      required: true
    }
  },

  methods: {
    updateModal (data) {
      this.$store.dispatch('updateModal', { identifier: this.identifier, data })
    },

    closeModal () {
      this.$store.dispatch('removeModal', this.identifier)
    }
  }
}
